export default "__VITE_ASSET__Ch0SmGOC__"